import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "reviews-section",
  id: "reviews"
}
const _hoisted_2 = { class: "section-shell" }
const _hoisted_3 = { class: "reviews-grid" }
const _hoisted_4 = { class: "review-card-top" }

import { Quote, Star } from "lucide-vue-next";
import "@/assets/styles/review.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewView',
  setup(__props) {

const reviews = [
  { text: "Freiraum hat nicht nur gebaut, sondern mitgedacht. Termine, Abstimmung und Ausführung waren vom ersten Gespräch bis zur Übergabe vorbildlich.", name: "Mara Hoffmann", role: "Projektleitung, Hagedorn Immobilien" },
  { text: "Unsere Außenanlage ist heute ein Ort, an dem Mitarbeitende wirklich gerne Pause machen. Genau diese Wirkung hatten wir uns gewünscht.", name: "Daniel Roth", role: "Geschäftsführer, Roth & Partner" },
  { text: "Ein starkes Team, das pragmatisch löst und dabei den gestalterischen Anspruch nie verliert. Die Zusammenarbeit war angenehm klar.", name: "Julia Stein", role: "Private Auftraggeberin" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "review-heading reveal" }, [
        _createElementVNode("span", { class: "eyebrow" }, "Vertrauen wächst"),
        _createElementVNode("h2", null, [
          _createTextVNode("Was bleibt, ist ein"),
          _createElementVNode("br"),
          _createElementVNode("em", null, "gutes Gefühl.")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reviews, (review) => {
          return _createElementVNode("article", {
            class: "review-card reveal",
            key: review.name
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Quote)),
              _createElementVNode("div", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createVNode(_unref(Star), { key: n })
                }), 64))
              ])
            ]),
            _createElementVNode("p", null, "„" + _toDisplayString(review.text) + "“", 1),
            _createElementVNode("footer", null, [
              _createElementVNode("strong", null, _toDisplayString(review.name), 1),
              _createElementVNode("span", null, _toDisplayString(review.role), 1)
            ])
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})